import { Colors } from "../constants/colors";
import { FONT_FAMILIES, getEmFontSize } from "./styles";

export default {
  styleOverrides: {
    root: {
      borderRadius: 4,
      boxShadow: "none",
      padding: "6px 20px",
      "&:hover": { boxShadow: "none" },
      "& .MuiTypography-root": {
        ...FONT_FAMILIES.REGULAR,
        textTransform: "uppercase",
        fontSize: getEmFontSize(15),
        ":disabled": {
          color: Colors.GREY300,
          backgroundColor: Colors.GREY250,
          borderColor: Colors.GREY250,
        },
      },
    },
  },
  variants: [
    {
      props: { variant: "primary" },
      style: {
        backgroundColor: Colors.YELLOW400,
        color: Colors.BLACK,
        border: `1px solid ${Colors.GREY500}`,
        "& .MuiTypography-root": {
          color: Colors.WHITE,
        },
        "&:hover": {
          color: Colors.GREY500,
          backgroundColor: Colors.WHITE,
        },
        ":disabled": {
          color: Colors.GREY300,
          backgroundColor: Colors.GREY250,
          borderColor: Colors.GREY250,
        },
      },
    },
    {
      props: { variant: "secondary" },
      style: {
        backgroundColor: Colors.WHITE,
        color: Colors.GREY500,
        border: `1px solid ${Colors.WHITE}`,
        "&:hover": {
          color: Colors.WHITE,
          backgroundColor: Colors.GREY500,
          borderColor: Colors.WHITE,
        },
        ":disabled": {
          color: Colors.GREY300,
          backgroundColor: Colors.WHITE,
          borderColor: Colors.GREY250,
        },
      },
    },
    {
      props: { variant: "utility" },
      style: {
        color: Colors.GREY500,
        border: "0px",
        "&:hover": {
          background: "none",
        },
        ":disabled": {
          color: Colors.GREY300,
        },
      },
    },
    {
      props: { variant: "text-link" },
      style: {
        backgroundColor: Colors.WHITE,
        color: Colors.BLUE500,
        border: "0px",
        "&:hover": {
          textDecoration: "underline",
          backgroundColor: Colors.WHITE,
        },
        ":disabled": {
          color: Colors.GREY300,
          backgroundColor: Colors.WHITE,
        },
      },
    },
    {
      props: { variant: "text-link-secondary" },
      style: {
        color: Colors.GREY500,
        border: "0px",
        "&:hover": {
          textDecoration: "underline",
          backgroundColor: Colors.WHITE,
        },
        ":disabled": {
          color: Colors.GREY300,
          backgroundColor: Colors.WHITE,
        },
      },
    },
    {
      props: { variant: "white" },
      style: {
        backgroundColor: Colors.WHITE,
        color: Colors.GREY500,
        borderRadius: "4px",
        border: `1px ${Colors.GREY300} solid`,
        ".button-caption": {
          color: "#979797",
          fontSize: "10px",
        },
      },
    },
    {
      props: { variant: "hovered" },
      style: {
        backgroundColor: Colors.GREY200,
        color: Colors.BLACK,
        border: `1px solid ${Colors.GREY200}`,
        "&:hover": {
          color: Colors.WHITE,
          backgroundColor: Colors.BLACK,
        },
      },
    },
    {
      props: { variant: "ey-disabled" },
      style: {
        "&.Mui-disabled": {
          background: Colors.GREY50,
          border: "0",
        },
      },
    },
    {
      props: { variant: "ey-child-disabled" },
      style: {
        "&.Mui-disabled": {
          background: Colors.GREY50,
          border: `1px solid ${Colors.GREY225}`,
        },
      },
    },
    {
      props: { variant: "toolbar" },
      style: {
        ...FONT_FAMILIES.REGULAR,
        textTransform: "uppercase",
        fontSize: getEmFontSize(14),
        color: Colors.WHITE,
        borderRadius: 0,
        padding: "6px 0px",
        margin: "0 20px",
        "&.active": {
          borderBottom: `2px solid ${Colors.WHITE}`,
        },
      },
    },
    {
      props: { variant: "transparent" },
      style: {
        backgroundColor: "transparent",
        color: Colors.WHITE,
        border: `1px solid ${Colors.WHITE}`,
        "&:hover": {
          backgroundColor: Colors.WHITE,
          color: Colors.BLACK,
        },
        ":disabled": {
          color: Colors.GREY300,
          backgroundColor: Colors.WHITE,
        },
      },
    },
  ],
};
